import * as actionTypes from "../../actions/cf3Questionnaire/actionTypes";
import { updateObject } from "../../utility/utility";

const initialState = {
  loading: false,
  cf3List: [],
  error: null,
  cf3Detail: null,
};

const cf3Start = (state) => {
  return updateObject(state, {
    error: null,
    loading: true,
  });
};

const cf3Fail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const getCf3List = (state, action) => {
  return updateObject(state, {
    cf3List: action.response,
    loading: false,
  });
};

const getCf3Detail = (state, action) => {
  return updateObject(state, {
    cf3Detail: action.response,
    loading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CF3_LIST_START:
      return cf3Start(state, action);
    case actionTypes.GET_CF3_LIST_FAIL:
      return cf3Fail(state, action);
    case actionTypes.GET_CF3_LIST_SUCCESS:
      return getCf3List(state, action);
    case actionTypes.GET_CF3_DETAIL_SUCCESS:
      return getCf3Detail(state, action);
    default:
      return state;
  }
};

export default reducer;
